import { useState, useEffect } from 'react';
import { getClientProState } from '../utils/clientPro';

/**
 * Estado de MekaFix Pro del cliente para usarlo en render.
 * `getClientProState` es asíncrona (el regalo de fundador depende de
 * `config/launch.openedAt`), así que las pantallas que lo necesitan en render no
 * pueden llamarla directamente — y por eso varias se quedaron mirando solo el riel
 * legacy, dejando fuera a los suscriptores de Azul y a los fundadores.
 */
export function useClientPro(profile) {
  const [state, setState] = useState({ isPro: false, via: null, until: null, loading: true });

  useEffect(() => {
    let vivo = true;
    getClientProState(profile)
      .then(s => { if (vivo) setState({ ...s, loading: false }); })
      .catch(() => { if (vivo) setState({ isPro: false, via: null, until: null, loading: false }); });
    return () => { vivo = false; };
  }, [profile]);

  return state;
}
